define([
	"dojo/_base/declare",
	"csi/heading/_base",
	"csi/html",
	"csi/widget/InlineTextarea",
	"csi/widget/ValidationTextArea",
	"./String"
], function(declare, csiHeading, html, InlineTextarea, ValidationTextArea, StringRen) {

	return declare(StringRen, {
		nTextareaLines: 10,

		/**
		 * @override
		 * Add CSS indicates that it contains rich text in the case of exporting to Excel
		 */
		_getRenderCSS: function(ctx, h, refNode) {
			return this.inherited(arguments) + (ctx.bExcel ? (" " + html.CSS_EXCEL_WRAP) : "");
		},

		canBeLarge: function(/*Context*/ctx, /*Heading*/h) {
			// summary: value could be large
			return ctx.getParam(csiHeading.CTX_LARGE_FORMAT) ? 2 : 1;
		},

		canLink: function() {
			// summary: doesn't make sense to support linking here
			return false;
		},

		toHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*Object*/params) {
			// summary: return Textarea widget
			if (params.value == null) {
				params.value = this._getValue(ctx, h);
			}

			if (ctx.defView.getType() == "Form") {
				params.allowResize = true;
				return new ValidationTextArea(params);
			}

			return new InlineTextarea(params);
		},

		_toHtmlString: function(/*String*/value, /*DOMNode*/refNode, /*Boolean*/bCanLink) {
			// summary: render value for attribute - do not ue multiLineText as that will look and split on any "\n" character,
			// such as those introduced in localization resources. Here we just want to split by an actual return character.
			var a = value.split("\n");
			var n = a.length - 1;

			for (var i = 0; i <= n; i++) {
				html.text(refNode, a[i]);

				if (i < n) {
					refNode.appendChild(document.createElement("br"));
				}
			}
		},

		/** 
		 * @override
		 * return true if react renderer exists for given attribute type and should be used
		 */
		useReactInlineDialog() {
			return false;
		},
	});
});